import { useParams } from 'react-router-dom';
import { resolveNestedValue, selectContext, selectValues } from '@icp/form-renderer-core';
import { useStore } from '../store';
import { useCurrentData } from '../currentDataCtx';

export default function useHttpBody(config) {
  const routerParams = useParams();
  const store = useStore();
  const context = selectContext(store.getState());
  const formData = selectValues(store.getState());
  const currentData = useCurrentData();

  return resolveNestedValue({
    obj: config,
    currentData,
    formData,
    context,
    params: routerParams,
  });
}
